import { render } from "./RetailView.vue?vue&type=template&id=2e48cbf0&scoped=true"
import script from "./RetailView.vue?vue&type=script&lang=js"
export * from "./RetailView.vue?vue&type=script&lang=js"

import "./RetailView.vue?vue&type=style&index=0&id=2e48cbf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e48cbf0"]])

export default __exports__